import { AxiosResponse } from 'axios';
import api from './Api'

export const requestTossPaymentConfirm = (orderId: string, paymentKey: string, amount: string, usedPoint: number, selectedConselingBranch: string): Promise<AxiosResponse<ITossPayResult, any>> => {
    return api.post(`/tos-pay`, { orderId, paymentKey, amount, usedPoint, yogaCenterEnum: selectedConselingBranch });
}

export const cancelTossPay = (paymentKey: string, cancelReason: string) => {
    return api.post(`/tos-pay/cancel`, { paymentKey, cancelReason });
}